import React, { useEffect, useRef } from "react";
import images from "components/images";
import styled from "styled-components";
import { connect } from "react-redux";
import { redirectAction } from "store/actions";
import get from "lodash/get";
import WhatIsCA from "./WhatIsCA";
import WhenAndWhere from "./WhenAndWhere";
import CorePrinciples from "./CorePrinciples";
import Constitution from "./Constitution";
import ServerRules from "./ServerRules";
import EventRules from "./EventRules";
import MissionRules from "./MissionRules";
import DiversityStatement from "./DiversityStatement";
import HowToJoin from "./HowToJoin";
import InstallRepo from "./InstallRepo";
import JoiningMissions from "./JoiningMissions";
import HowToUseApp from "./HowToUseApp";
import EventBasics from "./EventBasics";
import SlotBasics from "./SlotBasics";

export const FaqPage = ({ hash, redirect, isMobile }) => {
  const components = [
    {
      sidebarText: "What is CA?",
      hash: "#what-is-ca",
      Component: WhatIsCA,
      refProp: useRef(null),
    },
    {
      sidebarText: "When and where?",
      hash: "#when-&-where",
      Component: WhenAndWhere,
      refProp: useRef(null),
    },
    {
      sidebarText: "Core Principles",
      hash: "#core-principles",
      Component: CorePrinciples,
      refProp: useRef(null),
    },
    {
      sidebarText: "Combined Arms Constitution",
      hash: "#constitution",
      Component: Constitution,
      refProp: useRef(null),
    },
    {
      sidebarText: "Server Rules",
      hash: "#server-rules",
      Component: ServerRules,
      refProp: useRef(null),
    },
    {
      sidebarText: "Event Rules",
      hash: "#event-rules",
      Component: EventRules,
      refProp: useRef(null),
    },
    {
      sidebarText: "Mission Making Rules",
      hash: "#mission-making-rules",
      Component: MissionRules,
      refProp: useRef(null),
    },
    {
      sidebarText: "Diversity & Inclusivity",
      hash: "#diversity",
      Component: DiversityStatement,
      refProp: useRef(null),
    },
    {
      sidebarText: "How to Join",
      hash: "#how-to-join",
      Component: HowToJoin,
      refProp: useRef(null),
    },
    {
      sidebarText: "Installing the repo",
      hash: "#install",
      Component: InstallRepo,
      refProp: useRef(null),
    },
    {
      sidebarText: "Joining a mission",
      hash: "#joining",
      Component: JoiningMissions,
      refProp: useRef(null),
    },
    {
      sidebarText: "How to use the Slotting App",
      hash: "#slotting",
      Component: HowToUseApp,
      refProp: useRef(null),
    },
    {
      sidebarText: "Event Basics",
      hash: "#event-basics",
      Component: EventBasics,
      refProp: useRef(null),
    },
    {
      sidebarText: "Slot Basics",
      hash: "#slot-basics",
      Component: SlotBasics,
      refProp: useRef(null),
    },
  ];

  useEffect(() => {
    const { refProp } = components.find((i) => i.hash === hash) || {};
    executeScroll({ ref: refProp });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hash]);

  const executeScroll = ({ ref }) => {
    get(ref, "current", { scrollIntoView: () => {} }).scrollIntoView();
  };

  return (
    <Container isMobile={isMobile}>
      <div>
        <div className={"main"}>
          {components.map(({ Component, refProp, sidebarText }) => (
            <>
              <Component
                refProp={refProp}
                isMobile={isMobile}
                key={sidebarText}
              />
              <div className={"divider"} key={`${sidebarText}-divider`} />
            </>
          ))}
        </div>
        {!isMobile && (
          <div className={"sidebar"}>
            <div>Quick Navigation Menu</div>
            {components.map(({ hash, sidebarText }) => {
              return (
                <div
                  id={"link"}
                  key={hash}
                  onClick={() => redirect(`/faq${hash}`)}
                >
                  {sidebarText}
                  <img src={images["ArrowDown"]} alt={"arrow_down"} />
                </div>
              );
            })}
          </div>
        )}
      </div>
    </Container>
  );
};

const Container = styled.div`
  background-color: #292b2f;

  #link:hover {
    background: #404040;
  }

  > div {
    display: flex;
    justify-content: ${(props) =>
      !!props.isMobile ? "center" : "space-between"};
    flex-direction: row;
    border-style: solid;
    border-color: #3b618ccc;
    background-color: #36393f;
    border-radius: 8px;
    border-width: 2px;
    padding: 15px;
    margin: 10px;
  }

  .divider {
    height: 1px;
    width: 100%;
    border-bottom-style: dashed;
  }

  .sidebar {
    max-height: 75vh;
    overflow-y: auto;
    width: 12%;
    position: fixed;
    right: 2%;
    border-style: solid;
    border-color: #3b618ccc;
    border-radius: 8px;
    background-color: #36393f;
    border-width: 2px;
    > div {
      display: flex;
      justify-content: space-between;
      align-items: center;
      cursor: pointer;
      background: #292b2f;
      border: 1px solid #3b618ccc;
      border-radius: 8px;
      margin: 5px;
      padding: 5px;
      > img {
        height: 25px;
        width: 25px;
      }
    }
  }

  .main {
    width: 85%;
    border-style: solid;
    border-color: #3b618ccc;
    border-radius: 8px;
    background-color: #36393f;
    border-width: 2px;
    padding: 5px;

    p {
      margin: 20px;
    }

    h2 {
      text-align: center;
      padding-top: 20px;
    }
  }

  .image {
    display: flex;
    place-content: center;
    > img {
      width: 90%;
    }
  }
`;

export const EmbeddedDoc = styled.p`
  padding: 5px;
  margin: 10px;
  text-align: center;

  iframe {
    height: 80vh;
    width: 60vw;
  }
`;

export const EmbeddedDocMobile = ({ href, text }) => {
  return (
    <p>
      {text}
      <a href={href} target="_blank" rel="noopener noreferrer">
        Due to viewing on mobile, click here for the link.
      </a>
    </p>
  );
};

const mapStateToProps = (state) => ({
  hash: get(state, "router.location.hash"),
  isMobile: get(state, "rootReducer.core.isMobile", false),
});

const mapDispatchToProps = {
  redirect: redirectAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(FaqPage);
